<template>
  <v-dialog v-model="isDialog" width="620px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card class="overflow-hidden">
      <v-card-title class="primary white--text">
        <v-toolbar-title>HỒ SƠ CHI TIẾT</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="isDialog = false">close</v-icon>
      </v-card-title>
      <v-row cols="12" md="12" class="pt-3 pl-5 pb-10">
        <v-col cols="12" md="12" class="pb-0 text-sm-body-4 d-flex">
          <v-col cols="12" md="4" class="pb-0 text-sm-body-4 gray">
            Nhóm đối tượng
          </v-col>
          <v-col cols="12" md="4" class="pb-0 text-sm-body-4">
            {{ groupInfo.title }}
          </v-col>
        </v-col>
        <v-col cols="12" md="12" class="pb-0 text-sm-body-4 d-flex">
          <v-col cols="12" md="4" class="pb-0 text-sm-body-4 gray">
            Phân loại
          </v-col>
          <v-col cols="12" md="4" class="pb-0 text-sm-body-4">
            {{ getCategory(groupInfo.category) }}
          </v-col>
        </v-col>
        <v-col cols="12" md="12" class="pb-0 text-sm-body-4 d-flex">
          <v-col cols="12" md="4" class="pb-0 text-sm-body-4 gray">
            Số lượng Học viên
          </v-col>
          <v-col cols="12" md="4" class="pb-0 text-sm-body-4">
            {{ totalStudent }}
          </v-col>
        </v-col>
      </v-row>
      <div v-if="groupInfo.category === 'custom'">
        <hr color="#E0E0E0" />
        <v-col class="d-flex justify-end">
          <v-btn  v-if="$auth.policies['update-priority-group-info'] || $auth.policies['update-tuition-fee-group-info']" sm="12" outlined color="#0D47A1" class="mx-1 mt-2 mb-2" @click="$refs['detail-dialog'].openDialog()">
            Sửa thông tin chi tiết
          </v-btn>
        </v-col>
      </div>
    </v-card>
    <UpdateGroupDialog action="update" ref="detail-dialog" />
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import UpdateGroupDialog from '@/modules/tuitionFee/group/GroupDialog'

export default {
  components: { UpdateGroupDialog },
  data() {
    return {
      isDialog: false,
    }
  },
  computed: {
    ...mapGetters({
      groupInfo: 'tuitionFeeGroup/groupInfo',
      totalStudent: 'tuitionFeeGroupStudent/countStudents',
    }),
  },
  methods: {
    openDialog() {
      this.isDialog = true
    },
    getCategory() {
      switch (this.groupInfo.category) {
        case 'default':
          return 'Mặc Định'
        case 'custom':
          return 'Bổ sung'
        default:
          return ''
      }
    },
  }
}
</script>
<style>
.gray {
  color: #757575;
}
</style>
